import React from 'react';

const Benefits = () => {
  const benefits = [
    {
      icon: 'fas fa-percentage',
      title: 'Najwyższy Wskaźnik Sukcesu',
      description: 'Nasze wnioski wygrywają w 95% przypadków dzięki doświadczeniu i profesjonalnemu podejściu.'
    },
    {
      icon: 'fas fa-clock',
      title: 'Oszczędność Czasu',
      description: 'Skoncentruj się na realizacji swojej misji, a my zajmiemy się pozyskiwaniem finansowania.'
    },
    {
      icon: 'fas fa-shield-alt',
      title: 'Gwarancja Jakości',
      description: 'Każdy wniosek przechodzi wieloetapową kontrolę jakości i jest przygotowany przez ekspertów.'
    },
    {
      icon: 'fas fa-users-cog',
      title: 'Wsparcie na Każdym Etapie',
      description: 'Od pomysłu po rozliczenie - zapewniamy kompleksową obsługę przez cały cykl życia projektu.'
    },
    {
      icon: 'fas fa-chart-line',
      title: 'Maksymalizacja Budżetu',
      description: 'Pomagamy uzyskać najwyższe możliwe dofinansowanie przy optymalnej strukturze kosztów.'
    },
    {
      icon: 'fas fa-network-wired',
      title: 'Sieć Kontaktów',
      description: 'Dostęp do naszej bazy partnerów, ekspertów i sieci kontaktów w branży grantowej.'
    }
  ];

  return (
    <section id="benefits" className="benefits">
      <div className="container">
        <div className="section-header">
          <div className="section-subtitle">Korzyści</div>
          <h2>Dlaczego warto postawić na Jasne Granty?</h2>
          <p>
            Współpraca z nami to inwestycja w sukces Twojej organizacji. 
            Zobacz, jakie korzyści zyskują nasi klienci.
          </p>
        </div>

        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <div className="benefit-icon">
                <i className={benefit.icon}></i>
              </div>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
